(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    



  if (!customElements.get('best-sellers-slider')) {
    class BestSellersSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = null;
      }

      connectedCallback() {
        this.initSlider();
      }

      initSlider() {
        const el = this.querySelector('.splide');
        if (!el) return;

        this.slider = new Splide(el, {
          type: 'slide',
          perPage: 3,
          gap: '20px',
          arrows: false,
          drag: false,
          pagination: false,
          breakpoints: {
            990: {
              perPage: 2,
              gap: '16px',
            },
            749: {
              perPage: 1.2,
              focus: 'center',
              drag: true,
              gap: '12px',
              padding: {
                left: '15px',
                right: '15px',
              }
            },
          },
        }).mount();
      }

      disconnectedCallback() {
        if (this.slider) {
          this.slider.destroy();
        }
      }
    }

    customElements.define('best-sellers-slider', BestSellersSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-tabs"] && !Shopify.designMode) return;
  try {
    
  class ProductDetailsTabs extends HTMLElement {
    constructor() {
      super();

      this.buttons = this.querySelectorAll('.product-details-tabs__button');

      this.panels = this.querySelectorAll('.product-details-tabs__panel');
    }

    connectedCallback() {
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const tab = button.dataset.tab;

          this.buttons.forEach((btn) => btn.classList.remove('is-active'));

          this.panels.forEach((panel) => panel.classList.remove('is-active'));

          button.classList.add('is-active');

          this.querySelector(`[data-panel="${tab}"]`)?.classList.add('is-active');
        });
      });
    }
  }

  customElements.define('product-details-tabs', ProductDetailsTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-series"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-series-slider')) {
    class ShopSeries extends HTMLElement {
      constructor() {
        super();
        this.slider = null;
      }

      connectedCallback() {
        this.initSlider();
      }

      initSlider() {
        const el = this.querySelector('.splide');
        if (!el) return;

        this.slider = new Splide(el, {
          type: 'loop',
          perPage: 3,
          perMove: 1,
          gap: '30px',
          arrows: false,
          drag: true,
          pagination: true,
          autoplay: true,
          interval: 4000,
          speed: 1200,
          breakpoints: {
            990: {
              perPage: 2,
              gap: '16px',
            },
            749: {
              perPage: 1,
              drag: true,
              gap: '12px',
              padding: {
                left: '15px',
                right: '15px',
              },
            },
          },
        }).mount();
      }

      disconnectedCallback() {
        if (this.slider) {
          this.slider.destroy();
        }
      }
    }

    customElements.define('shop-series-slider', ShopSeries);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-superhero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('universe-slider')) {
    class UniverseSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = null;
      }

      connectedCallback() {
        this.initSlider();
      }

      initSlider() {
        const el = this.querySelector('.splide');
        if (!el) return;

        this.slider = new Splide(el, {
          type: 'slide',
          perPage: 3,
          gap: '20px',
          arrows: false,
          drag: false,
          pagination: false,
          breakpoints: {
            990: {
              perPage: 2,
              gap: '16px',
            },
            749: {
              perPage: 1.2,
              focus: 'center',
              drag: true,
              gap: '12px',
              padding: {
                left: '15px',
                right: '15px',
              },
            },
          },
        }).mount();
      }

      disconnectedCallback() {
        if (this.slider) {
          this.slider.destroy();
        }
      }
    }

    customElements.define('universe-slider', UniverseSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
